import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faBuilding,
  faCalendar,
  faClock,
  faCog,
  faShareSquare,
  faEdit,
  faExpand,
  faFileExcel,
  faGlobe,
  faHistory,
  faHome,
  faLock,
  faLockOpen,
  faNetworkWired,
  faPlay,
  faPlug,
  faPlus,
  faRedoAlt,
  faSignInAlt,
  faSignOutAlt,
  faStop,
  faTable,
  faTachometerAlt,
  faTimes,
  faTrash,
  faUndo,
  faUser,
  faUserPlus,
  faLink,
  faCheck,
  faTh,
  faAlignJustify,
  faClone,
  faCopy,
  faWindowRestore,
  faWindowMaximize,
  faMinus,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faEye,
  faSlidersH,
  faIndent,
  faShieldAlt,
  faServer,
  faEnvelope,
  faFilter,
  faExchangeAlt,
  faDatabase,
  faPencilAlt,
  faInfoCircle,
  faCircle,
  faCompress,
  faCompressAlt,
  faLayerGroup,
  faRedo,
  faPause,
  faEllipsisH,
  faBolt,
  faCodeBranch,
  faInfo,
  faBusinessTime,
  faSave,
  faEject,
  faStepForward,
  faHourglassStart,
  faCogs,
  faSync,
  faDollarSign,
  faSitemap,
  faLocationArrow,
  faMagic,
  faCheckCircle,
  faComment,
  faSpinner,
  faEraser,
  faPaperclip,
  faFile,
  faFilePdf,
  faFileWord,
  faFileImage,
  faFileCode,
  faFileAlt,
  faDownload,
  faSearch,
  faChevronUp,
  faChevronDown,
  faKey,
  faFingerprint,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome,
  faUser,
  faLock,
  faLockOpen,
  faGlobe,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faFileExcel,
  faTable,
  faTachometerAlt,
  faNetworkWired,
  faHistory,
  faPlug,
  faBuilding,
  faExpand,
  faPlay,
  faStop,
  faRedoAlt,
  faPlus,
  faTimes,
  faTrash,
  faEdit,
  faEraser,
  faCalendar,
  faUndo,
  faClock,
  faCog,
  faShareSquare,
  faLink,
  faCheck,
  faTh,
  faAlignJustify,
  faClone,
  faCopy,
  faWindowRestore,
  faWindowMaximize,
  faMinus,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faEye,
  faSlidersH,
  faIndent,
  faEnvelope,
  faDatabase,
  faFilter,
  faExchangeAlt,
  faEnvelope,
  faShieldAlt,
  faServer,
  faPencilAlt,
  faInfoCircle,
  faCircle,
  faCompress,
  faCompressAlt,
  faLayerGroup,
  faRedo,
  faPause,
  faEllipsisH,
  faBolt,
  faBusinessTime,
  faInfo,
  faCodeBranch,
  faSave,
  faEject,
  faStepForward,
  faHourglassStart,
  faCogs,
  faDollarSign,
  faSync,
  faSitemap,
  faLocationArrow,
  faMagic,
  faCheckCircle,
  faComment,
  faSpinner,
  faPaperclip,
  faFile,
  faFilePdf,
  faFileWord,
  faFileImage,
  faFileCode,
  faFileAlt,
  faDownload,
  faSearch,
  faChevronUp,
  faChevronDown,
  faKey,
  faFingerprint,
  faUpload
);

export { FontAwesomeIcon };
